/**
 * Composable for making authenticated API calls
 * Automatically includes Firebase ID token in Authorization header
 */
export function useAuthFetch() {
    const { $auth } = useNuxtApp()

    /**
     * Make an authenticated fetch request
     */
    async function authFetch<T>(url: string, options: Parameters<typeof $fetch>[1] = {}): Promise<T> {
        let token: string | null = null

        if ($auth?.currentUser) {
            try {
                token = await $auth.currentUser.getIdToken()
            } catch (error) {
                console.error('[authFetch] Error getting auth token:', error)
            }
        }

        const headers: Record<string, string> = {
            ...(options.headers as Record<string, string> || {})
        }

        if (token) {
            headers.Authorization = `Bearer ${token}`
        }

        return $fetch<T>(url, {
            ...options,
            headers
        })
    }

    return {
        authFetch
    }
}
